import React from 'react'
import {NormasConducta} from "../components/lineamientos/NormasConducta";

export const NormasConductaPage = () => {
    return (
        <NormasConducta/>
    )
}
